<script>
import Swal from "sweetalert2";
export default {
    data() {
        return {
            rfq: {
                rfqNumber: "",
                id: 0,
            },
        };
    },
    methods: {
        getRFQ(row){
            this.rfq = {
                rfqNumber: row.rfqNumber,
                id: row.id,
            };
        },
        changeNumber() {
            Swal.fire({
                title: "Are you sure?",
                text: `You want to update the rfq number?`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#28c76f",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, update it!",
            }).then((result) => {
                if(!result.value){
                    return;
                }
                this.$store
                    .dispatch("rfq/UpdateRFQNo", {
                        id: this.rfq.id,
                        body: this.rfq.rfqNumber
                    })
                    .then((res) => {
                        if (res.data.error) {
                            return this.showToast(res.data.errorMessage, "error");
                        }
                        this.$emit('rfqNumberChanged', this.rfq.rfqNumber);
                        this.showToast("Successfully changed", "success");
                        this.$bvModal.hide("rfq-number-modal");
                    })
                    .catch(() => {
                        this.showToast("Something went wrong!", "error");
                    });
            });
        },
    },
}
</script>
<template>
    <b-modal
        id="rfq-number-modal"
        title="Change RFQ Number"
        size="sm"
        title-class="font-18"
        hide-footer
        no-close-on-backdrop
    >
        <form @submit.prevent="changeNumber">
            <div class="p-3">
                <b-form-group label="RFQ Number" label-for="rfq-number">
                    <b-form-input
                        id="rfq-number"
                        v-model="rfq.rfqNumber"
                        placeholder="Enter RFQ Number"
                        required
                    ></b-form-input>
                </b-form-group>
            </div>
            <div class="modal-footer">
                <button 
                    type="submit"
                    class="btn btn-primary"
                >Set New RFQ No.</button>
                <button 
                    type="button"
                    class="btn btn-link"
                    @click="$bvModal.hide('rfq-number-modal')"
                >Cancel</button>
            </div>
        </form>
    </b-modal>
</template>